import type { PortalSession } from "../auth/session.js";

/** Avisos de la cuenta (PP-68, ADR-027): de la cuenta global, no de una planta. */
export interface NotificationPreferences {
  readonly offerMail: boolean;
}

export interface NotificationsPort {
  read(session: PortalSession): Promise<NotificationPreferences>;
  save(session: PortalSession, value: NotificationPreferences): Promise<NotificationPreferences>;
}

/** Sin cuerpo remoto: la UI solo distingue que no se pudo. */
export class NotificationsError extends Error {}
